import { useFormik } from 'formik';
import * as yup from 'yup';
import { useSnackbar } from 'notistack';
import { Button, Dialog, DialogActions, DialogContent, DialogProps, DialogTitle, Grid, TextField } from '@mui/material';

import { Locality } from '@/types';
import { useUpdateLocalityMutation } from '@/services';
import { messages } from '@/utils/helpers';

export interface UpdateLocalityProps extends DialogProps {
  locality: Locality;
  onClose(): void;
}

const UpdateLocality: React.FC<UpdateLocalityProps> = ({ locality, onClose, ...props }) => {
  const { enqueueSnackbar } = useSnackbar();

  const [updateLocality, updateLocalityResponse] = useUpdateLocalityMutation();

  const { values, errors, touched, handleSubmit, handleChange } = useFormik<Locality>({
    initialValues: locality ?? {
      name: '',
    },
    enableReinitialize: true,
    validationSchema: yup.object().shape({
      name: yup.string().required(messages.form.REQUIRED),
    }),
    async onSubmit(locality, { resetForm }) {
      try {
        await updateLocality(locality).unwrap();

        onClose();
        resetForm();
      } catch (error) {
        enqueueSnackbar(error.data, { variant: 'error' });
      }
    },
  });

  return (
    <Dialog fullWidth {...props}>
      <DialogTitle fontWeight="bold">Редактировать населенный пункт</DialogTitle>

      <form onSubmit={handleSubmit}>
        <DialogContent dividers>
          <Grid container spacing={3}>
            <Grid item lg={6} md={6} xs={12}>
              <TextField
                name="name"
                label="Наименование"
                placeholder="Введите значение"
                value={values.name}
                onChange={handleChange}
                disabled={updateLocalityResponse.isLoading}
                error={touched.name && Boolean(errors.name)}
                helperText={touched.name ? errors.name : ''}
                fullWidth
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button
            type="button"
            color="secondary"
            variant="outlined"
            disabled={updateLocalityResponse.isLoading}
            onClick={onClose}
          >
            Закрыть
          </Button>

          <Button type="submit" variant="contained" disabled={updateLocalityResponse.isLoading}>
            Редактировать
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default UpdateLocality;
